<template>
    <div class="image-gallery">
        <!-- Desktop Layout (above 666px) -->
        <div class="desktop-layout">
            <div class="top-row">
                <img
                    src="@/assets/images/our-story/1.jpg"
                    alt="Our Story Image 1"
                    class="gallery-image image-1"
                    @click="openPreview($event.target.src, 'Our Story Image 1')"
                />
                <img
                    src="@/assets/images/our-story/2.jpg"
                    alt="Our Story Image 2"
                    class="gallery-image image-2"
                    @click="openPreview($event.target.src, 'Our Story Image 2')"
                />
                <img
                    src="@/assets/images/our-story/3.jpg"
                    alt="Our Story Image 3"
                    class="gallery-image image-3"
                    @click="openPreview($event.target.src, 'Our Story Image 3')"
                />
            </div>
            <div class="bottom-row">
                <div class="bottom-left-block">
                    <img
                        src="@/assets/images/our-story/4.jpg"
                        alt="Our Story Image 4"
                        class="gallery-image image-4"
                        @click="openPreview($event.target.src, 'Our Story Image 4')"
                    />
                    <div class="bottom-left-row">
                        <div class="small-bottom-left-block">
                            <img
                                src="@/assets/images/our-story/6.jpg"
                                alt="Our Story Image 6"
                                class="gallery-image image-6"
                                @click="openPreview($event.target.src, 'Our Story Image 6')"
                            />
                            <img
                                src="@/assets/images/our-story/9.jpg"
                                alt="Our Story Image 9"
                                class="gallery-image image-9"
                                @click="openPreview($event.target.src, 'Our Story Image 9')"
                            />
                        </div>
                        <img
                            src="@/assets/images/our-story/7.jpg"
                            alt="Our Story Image 7"
                            class="gallery-image image-7"
                            @click="openPreview($event.target.src, 'Our Story Image 7')"
                        />
                    </div>
                </div>
                <div class="bottom-right-block">
                    <img
                        src="@/assets/images/our-story/5.jpg"
                        alt="Our Story Image 5"
                        class="gallery-image image-5"
                        @click="openPreview($event.target.src, 'Our Story Image 5')"
                    >
                    <img
                        src="@/assets/images/our-story/8.jpg"
                        alt="Our Story Image 8"
                        class="gallery-image image-8"
                        @click="openPreview($event.target.src, 'Our Story Image 8')"
                    />
                </div>
            </div>
        </div>

        <!-- Mobile Layout (below 500px) -->
        <div class="mobile-layout">
            <img
                src="@/assets/images/our-story/1.jpg"
                alt="Our Story Image 1"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 1')"
            />
            <img
                src="@/assets/images/our-story/2.jpg"
                alt="Our Story Image 2"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 2')"
            />
            <img
                src="@/assets/images/our-story/3.jpg"
                alt="Our Story Image 3"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 3')"
            />
            <img
                src="@/assets/images/our-story/4.jpg"
                alt="Our Story Image 4"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 4')"
            />
            <img
                src="@/assets/images/our-story/5.jpg"
                alt="Our Story Image 5"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 5')"
            />
            <img
                src="@/assets/images/our-story/6.jpg"
                alt="Our Story Image 6"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 6')"
            />
            <img
                src="@/assets/images/our-story/7.jpg"
                alt="Our Story Image 7"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 7')"
            />
            <img
                src="@/assets/images/our-story/8.jpg"
                alt="Our Story Image 8"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 8')"
            />
            <img
                src="@/assets/images/our-story/9.jpg"
                alt="Our Story Image 9"
                class="mobile-gallery-image"
                @click="openPreview($event.target.src, 'Our Story Image 9')"
            />
        </div>

        <!-- Image Preview Dialog using Vuetify -->
        <v-dialog v-model="isPreviewOpen">
            <v-card class="preview-card">
                <img
                    :src="previewImage"
                    :alt="previewAlt"
                    class="preview-image"
                />
            </v-card>
            <!-- Close button anchored to top right of screen -->
            <button
                @click="closePreview"
                class="close-button"
                aria-label="Close image preview"
            >
                ×
            </button>
        </v-dialog>

    </div>
</template>

<script>
export default {
  name: 'ImageGallery',
  data() {
    return {
      isPreviewOpen: false,
      previewImage: '',
      previewAlt: ''
    }
  },
  methods: {
    openPreview(imageSrc, imageAlt) {
      this.previewImage = imageSrc;
      this.previewAlt = imageAlt;
      this.isPreviewOpen = true;
    },
    closePreview() {
      this.isPreviewOpen = false;
    }
  }
}
</script>

<style scoped>
.image-gallery {
    margin-bottom: 80px;
    margin-top: 60px;
    width: 100%;
}

/* Default: Desktop Layout visible, Mobile Layout hidden */
.desktop-layout {
    display: block;
}

.mobile-layout {
    display: none;
}

.top-row {
    display: flex;
    flex-direction: row;
    gap: 6.72478206px;
    height: 160px;
    margin-bottom: 6.72478206px;
}

.small-bottom-left-block {
    display: flex;
    flex-direction: column;
    gap: 6.72478206px;
    width: 163px;
}

.bottom-left-row {
    display: flex;
    flex-direction: row;
    gap: 6.72478206px;
    height: 160px;
    min-height: 160px;
}

.bottom-left-block {
    display: flex;
    flex-direction: column;
    gap: 6.72478206px;
    width: 280px;
    min-width: 280px;
}

.bottom-right-block {
    display: flex;
    flex-direction: column;
    gap: 6.72478206px;
    width: 313px;
    min-width: 313px;
}

.bottom-row {
    display: flex;
    flex-direction: row;
    gap: 6.72478206px;
    height: 250px;
    min-height: 250px;
}

.gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    transition: all 0.3s ease;
}

.gallery-image:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    filter: brightness(1.08);
}

.image-7 {
    width: 110px;
}

/* Mobile Layout Styles - only applied in media query */
.mobile-gallery-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    cursor: pointer;
    transition: all 0.3s ease;
}

.mobile-gallery-image:hover {
    transform: scale(1.01);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    filter: brightness(1.05);
}

.preview-card {
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    border-radius: 0;
}

.preview-image {
    max-height: 80vh;
    max-width: 90vw;
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    margin: 0;
    padding: 0;
}

:deep(.v-overlay__content) {
    width: auto !important;
}

.close-button {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.4);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.close-button:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: scale(1.1);
}

.close-button:focus {
    outline: 2px solid #fff;
    outline-offset: 2px;
}

/* Mobile Layout (below 666px) */
@media (max-width: 666px) {
    .image-gallery {
        margin-bottom: 20px;
    }

    .desktop-layout {
        display: none;
    }

    .mobile-layout {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
    }

    .mobile-gallery-image {
        max-width: 400px;
        width: 100%;
    }
}

</style>
